<template>
  <v-btn
    color="white"
    class="justify-start px-3 grey--text text--darken-1"
    x-large
    block
    @click="authWithGoogle()"
  >
    <span v-if="flow === 'signup'" class="long-text">{{ $t('login.googleAuthSignup') }}</span>
    <span v-if="flow === 'login'">{{ $t('login.googleAuthLogin') }}</span>
    <div class="flex-grow-1" />
    <img
      v-if="!loading"
      class="logo"
      src="/consultations/img/icons/google.svg"
      alt=""
    >
    <v-progress-circular
      v-if="loading"
      :size="24"
      :width="3"
      indeterminate
      color="grey darken-1"
    />
  </v-btn>
</template>

<script>
import { trackEvent } from '@/utils/tracking'

export default {
  name: 'GoogleBtn',
  props: {
    flow: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    async authWithGoogle () {
      this.loading = true
      this.error = false
      try {
        await this.$auth.loginWith('google')
        if (this.flow === 'signup') {
          trackEvent('Sign up completed', { channel: 'google' }, this.$auth.user)
        }
      } catch (error) {
        this.$rollbar.error(error)
        this.loading = false
        this.error = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.v-application--is-ltr {
  .long-text {
    font-size: 12px!important;
  }
}
.logo {
  display: inline-block;
  width: 22px;
  height: 22px;
}
</style>
